import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { GiftcardService } from '../ecom-gift-card/ecom-giftcard.service';
import { EComService } from '../ecom-services/ecom-common.service';
import { EComWebStorage } from '../ecom-services/ecom-webstorage.services';


@Component({
  selector: 'app-ecom-gift-card-result',
  templateUrl: './ecom-gift-card-result.component.html',
  styleUrls: ['./ecom-gift-card-result.component.scss']
})
export class GiftCardResultComponent implements OnInit {

  @ViewChild('screen', { static: false }) screen: ElementRef;
  // 0 = thin, 1 = thick

  giftcard: any;
  imageSource: any;
  isLoading: boolean = false;

  constructor(private sanitizer: DomSanitizer, public giftcardService: GiftcardService,
    private activatedRoute: ActivatedRoute, public ecomservice: EComService,
    public webstorage: EComWebStorage
  ) { }

  async ngOnInit() {
    await this.fetchPurchasedGiftCard();
  }


  async fetchPurchasedGiftCard() {
    this.activatedRoute.queryParams.subscribe(async params => {

      const company_id = params['c'];;
      const id = params['id'];

      const res = await this.giftcardService.fetchPurchasesGiftcard({ company_id, id: +id }).toPromise();

      if (res.listValue && res.listValue) {
        const data = res.listValue;
        this.giftcard = data;
        console.log(data);

        const imageUrl = 'data:image/jpeg;base64,' + data.barcode;
        this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);

        this.webstorage.localSt_user_order_giftcard = null;
      }
    });
  }


  downloadGiftCard() {
    this.isLoading = true;
    html2canvas(this.screen.nativeElement, {
      allowTaint: true,
      useCORS: true
    }).then(canvas => {
      this.isLoading = false;
      const link = document.createElement('a');
      link.download = `${this.giftcard.name}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  }






}


